module.exports = __webpack_public_path__ + "static/logo-5bd28689152255488f02de1085f4533e.png";